import { api } from '../config/api';

const buildQuery = (params = {}) => {
  const queryParams = new URLSearchParams();
  if (params.active_only !== undefined) {
    if (params.active_only === true || params.active_only === 'true') {
      queryParams.append('is_active', 'true');
    }
  }
  return queryParams.toString();
};

const buildEndpoint = (base, params) => {
  const query = buildQuery(params);
  return `/catalogs/${base}/${query ? `?${query}` : ''}`;
};

const makeService = (base) => ({
  getAll: async (params = {}) => {
    const endpoint = buildEndpoint(base, params);
    if (process.env.NODE_ENV === 'development') {
      console.log('[catalogService] fetch ejecutado', { base, endpoint, params });
    }
    return api.get(endpoint, { normalizeListResponse: true });
  },
  getById: async (id) => api.get(`/catalogs/${base}/${id}/`),
  create: async (data) => api.post(`/catalogs/${base}/`, data),
  update: async (id, data) => api.put(`/catalogs/${base}/${id}/`, data),
  delete: async (id) => api.delete(`/catalogs/${base}/${id}/`),
});

export const catalogService = {
  countries: makeService('countries'),
  clientTypes: makeService('client-types'),
  paymentMethods: makeService('payment-methods'),
  creditDays: makeService('credit-days'),
  balancePayments: makeService('balance-payments'),
  brands: makeService('brands'),
  productLines: makeService('product-lines'),
  productTags: makeService('product-tags'),
  packagingTypes: makeService('packaging-types'),
  batteryTypes: makeService('battery-types'),
  factories: makeService('factories'),
  states: makeService('states'),
  storeFormats: makeService('store-formats'),
  fairs: makeService('fairs'),
  salespeople: makeService('salespeople'),
  addressTypes: makeService('address-types'),
  advancePayments: makeService('advance-payments'),
  priceLists: {
    ...makeService('price-lists'),
    // ── Items (productos con precio) de una lista ──────────────
    getItems: async (priceListId, activeOnly = false) =>
      api.get(`/catalogs/price-lists/${priceListId}/items${activeOnly ? '?active_only=true' : ''}`),
    addItem: async (priceListId, data) =>
      api.post(`/catalogs/price-lists/${priceListId}/items/add`, data),
    updateItem: async (priceListId, itemId, data) =>
      api.patch(`/catalogs/price-lists/${priceListId}/items/${itemId}`, data),
    deleteItem: async (priceListId, itemId) =>
      api.delete(`/catalogs/price-lists/${priceListId}/items/${itemId}`),
    getProductPrice: async (productId, priceListId) =>
      api.get(`/catalogs/price-list-items/${productId}/?price_list_id=${priceListId}`),
    getProductPrices: async (productId) =>
      api.get(`/catalogs/price-list-items/${productId}/`),
    upsertProductPrice: async (productId, priceListId, priceFobUnit) =>
      api.post(`/catalogs/price-list-items/${productId}/`, { price_list_id: priceListId, price_fob_unit: priceFobUnit }),
    deleteProductPrice: async (productId, priceListId) =>
      api.delete(`/catalogs/price-list-items/${productId}/?price_list_id=${priceListId}`),
  },
  discountLists: {
    ...makeService('discount-lists'),
    getRules: async (discountListId) =>
      api.get(`/catalogs/discount-lists/${discountListId}/rules`),
    addRule: async (discountListId, data) =>
      api.post(`/catalogs/discount-lists/${discountListId}/rules/add`, data),
    updateRule: async (discountListId, ruleId, data) =>
      api.patch(`/catalogs/discount-lists/${discountListId}/rules/${ruleId}`, data),
    deleteRule: async (discountListId, ruleId) =>
      api.delete(`/catalogs/discount-lists/${discountListId}/rules/${ruleId}`),
  },
};
